import React from 'react';
import TPGrid from 'components/TP-UI/TPGrid';
import PropTypes from 'prop-types';
import FormError from 'modules/common/FormError';
import { MFA_TYPE } from '../../../../constants';
import EnableAuthenticatorMfaForm from '../EnableAuthenticatorMfaForm';
import EnableSmsCodeMfaForm from '../EnableSmsCodeMfaForm';

const EnableMfaForm = ({
  form,
  type,
  phoneNumber,
  setupPhoneRequired,
  sendSmsRequired,
  allowResend,
  qrCode,
  secret,
  error,
  submitFailed,
  onCodeSent,
  onCodeExpired,
}) => {
  return (
    <TPGrid container spacing={3} direction="column">
      {submitFailed && error && (
        <TPGrid item xs={12}>
          <FormError error={error} />
        </TPGrid>
      )}
      {type === MFA_TYPE.SMS ? (
        <TPGrid item xs={12}>
          <EnableSmsCodeMfaForm
            form={form}
            phoneNumber={phoneNumber}
            setupPhoneRequired={setupPhoneRequired}
            sendSmsRequired={sendSmsRequired}
            allowResend={allowResend}
            onCodeSent={onCodeSent}
            onCodeExpired={onCodeExpired}
          />
        </TPGrid>
      ) : (
        <TPGrid item xs={12}>
          <EnableAuthenticatorMfaForm qrCode={qrCode} secret={secret} />
        </TPGrid>
      )}
    </TPGrid>
  );
};

EnableMfaForm.propTypes = {
  form: PropTypes.string.isRequired,
  type: PropTypes.oneOf([...Object.values(MFA_TYPE), '']),
  phoneNumber: PropTypes.string,
  setupPhoneRequired: PropTypes.bool,
  sendSmsRequired: PropTypes.bool,
  allowResend: PropTypes.bool,
  qrCode: PropTypes.string,
  secret: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  submitFailed: PropTypes.bool,
  onCodeSent: PropTypes.func,
  onCodeExpired: PropTypes.func,
};

export default EnableMfaForm;
